module.exports = __webpack_public_path__ + "img/process.59f987f2.jpg";